import { withStyles } from '@material-ui/core';

import AutocompleteInput from './component';
import styles from './styles';

export default withStyles(styles)(AutocompleteInput);
